document.addEventListener("DOMContentLoaded", function () {
	setTimeout(function () {
		$(".img-resize").resizeToParent();
	}, 500)
});